import { Auth0ClaimsResponse } from '../sdk/auth0Types';
/** @hidden */
export function transformAuth0Claims(claims: Auth0ClaimsResponse): Auth0ClaimsResponse | {} {
  if (claims && typeof claims === 'object') {
    let transformed = { ...claims };
    transformed = { ...transformed, uuid: transformed.sub, accessToken: transformed.__raw };
    delete transformed.__raw;
    delete transformed.sub;
    return transformed;
  }
  return {};
}
